import { CRMAPIBase } from "@api/crmApiBase";
import { RequestResult } from "@api/responseModels/requestResult";
import { HistorySearchParams } from "types/getParams";

export class SearchHistoryGroup extends CRMAPIBase {
    async getHistorySearch(): Promise<RequestResult<any>> {
        const result = await this.get<null>('/search-history');
        return result;
    }
    async addToHistorySearch(searchFields: HistorySearchParams): Promise<RequestResult<any>> {
        const result = await this.post<null>('/search-history', searchFields);
        return result;
    }
}
